<template>
  <div class="mb-10">
    <v-form
      ref="form"
      v-model="isPlayerDetailsFormValid"
      @submit.prevent="handleContinueToPayment"
    >
      <PlayerRegistrationFormTeamCard
        @registrationOptionSelected="isRegistrationOptionSelected = true"
      />
      <PlayerRegistrationFormPlayerCard
        :disabled="!isRegistrationOptionSelected"
      />
      <PlayerRegistrationFormProfileCard
        v-if="Object.keys(playerProfileForm).length"
        :disabled="!isRegistrationOptionSelected"
        :isFormValidated="isFormValidated"
      />
      <PlayerRegistrationFormFansAndFollowersCard
        v-if="playerRegistration.value && isRegistrationOptionSelected"
      />
      <PlayerRegistrationFormAddOnsCard
        v-if="
          Object.keys(playerRegistrationAddOns).length &&
            isRegistrationOptionSelected
        "
      />
      <div class="d-flex justify-end mt-10">
        <CommonButton
          :disabled="
            isMoveToPlayerRegistrationFormPaymentDetailsDisable ||
              playerAvatar.isFileUploading ||
              !isRegistrationOptionSelected
          "
          :label="$t('team_registration.continue_to_payment')"
          :loading="isSavePlayerRegistrationDetailsPending"
          color="secondary"
          customClassName=""
          height="50"
          notCapitalize
          @handleClick="handleContinueToPayment"
        />
      </div>
    </v-form>
  </div>
</template>

<script>
import PlayerRegistrationFormPlayerCard from "./PlayerRegistrationFormPlayerCard";
import PlayerRegistrationFormTeamCard from "./PlayerRegistrationFormTeamCard";
import PlayerRegistrationFormProfileCard from "./PlayerRegistrationFormProfileCard";
import PlayerRegistrationFormFansAndFollowersCard from "./PlayerRegistrationFormFansAndFollowersCard";
import PlayerRegistrationFormAddOnsCard from "./PlayerRegistrationFormAddOnsCard";
import CommonButton from "../common/CommonButton";
import { mapActions, mapGetters, mapMutations } from "vuex";
import { ModuleTypes } from "../../../store/ModuleTypes";
import { RegistrationAnswerType } from "../enums/AnswerType";
import PlayerRegistrationPlayerDetailsBase from "./PlayerRegistrationPlayerDetailsBase";
import {
  RegistrationQuestionsAddressFields,
  RegistrationQuestionsTitlePlayerContext
} from "../enums/RegistrationQuestionsTitle";
import { bus } from "@/main";

export default {
  name: "PlayerRegistrationFormPlayerDetails",
  components: {
    PlayerRegistrationFormTeamCard,
    PlayerRegistrationFormPlayerCard,
    PlayerRegistrationFormProfileCard,
    PlayerRegistrationFormFansAndFollowersCard,
    PlayerRegistrationFormAddOnsCard,
    CommonButton
  },
  mixins: [PlayerRegistrationPlayerDetailsBase],
  props: {
    moveToFormStep: {
      type: Function,
      required: true
    }
  },
  data: () => ({
    isPlayerDetailsFormValid: false,
    isFileAttachmentValid: false,
    isSavePlayerRegistrationDetailsPending: false,
    isFormValidated: false,
    isRegistrationOptionSelected: false
  }),

  mounted() {
    const { registrationId, playerId } = this.$route.params;
    this.fetchPlayersToRegistration({
      registrationId
    });
    // if (playerId) {
    //   this.fetchPlayerRegistrationDetails({
    //     registrationId,
    //     playerId
    //   });
    // }
  },

  computed: {
    ...mapGetters(ModuleTypes.PLAYER_REGISTRATION, [
      "playerRegistration",
      "playerProfileForm",
      "teamRegistration",
      "fansAndFollowers",
      "playerRegistrationAddOns",
      "isMoveToPlayerRegistrationFormPaymentDetailsDisable",
      "playerAvatar"
    ]),

    isRenderFieldsForCustomTeam() {
      return !this.$route.params?.orgUnitId;
    }
  },

  methods: {
    ...mapMutations(ModuleTypes.PLAYER_REGISTRATION, [
      "setRegistrationPlayerId"
    ]),
    ...mapActions(ModuleTypes.PLAYER_REGISTRATION, [
      "savePlayerRegistrationDetails",
      "fetchPlayerRegistrationDetails",
      "fetchPlayersToRegistration"
    ]),

    async handleContinueToPayment() {
      const { CITY, STATE, ZIP_CODE } = RegistrationQuestionsTitlePlayerContext;
      this.isFormValidated = true;
      this.isFileAttachmentValid = !this.playerProfileForm.some(
        ({ type, optional, value }) =>
          type === RegistrationAnswerType.FILE_ATTACHMENT &&
          !optional &&
          !value?.length
      );
      const addressQuestionAnswer = [];
      this.playerProfileForm.forEach(question => {
        if (RegistrationQuestionsAddressFields.includes(question.label)) {
          addressQuestionAnswer.push(question.value);
        }
      });

      const formContent = this.playerProfileForm
        .map(item => {
          const {
            DATE,
            OPTIONS_CHOOSE_MULTIPLE,
            FILE_ATTACHMENT
          } = RegistrationAnswerType;
          const { id, value, type, name } = item;
          let answer;
          let fileAttachmentList;
          switch (type) {
            case DATE:
              {
                let formattedDate;
                if (value?.includes("-")) {
                  const date = value.split("-");
                  formattedDate = date[2] + "/" + date[1] + "/" + date[0];
                } else {
                  formattedDate = value;
                }
                answer = [formattedDate];
              }
              break;
            case OPTIONS_CHOOSE_MULTIPLE:
              answer = Array.isArray(value) ? value : [value];
              break;
            case FILE_ATTACHMENT:
              fileAttachmentList = value;
              break;
            default:
              answer = [value];
          }

          return {
            name,
            questionId: id,
            ...(type === RegistrationAnswerType.FILE_ATTACHMENT
              ? {}
              : {
                  answer:
                    item.name ===
                    RegistrationQuestionsTitlePlayerContext.PLAYER_ADDRESS
                      ? addressQuestionAnswer
                      : answer
                }),
            ...(type === RegistrationAnswerType.FILE_ATTACHMENT && value?.length
              ? { fileAttachmentList }
              : {})
          };
        })
        .filter(
          item =>
            ![CITY, STATE, ZIP_CODE].includes(item.name) &&
            (item.answer || item.fileAttachmentList)
        );

      const body = {
        formContent,
        registrationOptionId:
          this.teamRegistration?.value || this.$route.params.orgUnitId,
        fansAndFollowersForm: this.fansAndFollowers
      };
      this.$refs.form.validate();
      const allRequiredPresent = this.playerProfileForm
        .filter(f => !f.optional)
        .every(f => f.value.length > 0);
      if (
        this.isPlayerDetailsFormValid &&
        this.isFileAttachmentValid &&
        allRequiredPresent
      ) {
        this.isSavePlayerRegistrationDetailsPending = true;
        await this.savePlayerRegistrationDetails({
          registrationId: this.$route.params.registrationId,
          playerId: this.playerRegistration?.value,
          body,
          successCallback: async ({ data }) => {
            const registrationPlayerId =
              this.playerRegistration?.value === "new_player"
                ? data.playerRegistrationId
                : data.id;
            if (!this.$route.params.playerId) {
              this.$router.push(`${this.$route.path}/player/${data.playerId}`);
            }
            this.setRegistrationPlayerId({ registrationPlayerId });

            this.moveToFormStep && this.moveToFormStep(2);
          }
        });
        this.isSavePlayerRegistrationDetailsPending = false;
      } else if (!allRequiredPresent) {
        bus.$emit(
          "errorSnack",
          "Please enter a value for all required fields."
        );
      }
    }
  }
};
</script>

<style scoped></style>
